module.exports = __webpack_public_path__ + "img/sky.a35e8203.png";